import { Component, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { IChat } from '@common/models/Chat/IChat';
import { Subscription } from 'rxjs';
import { ChatServices } from '@app/services/chat.service';
import { DomSanitizer } from '@angular/platform-browser';
import { IChatRequest } from '@common/models/Chat/IChatRequest';
import { ChatType } from '@common/enums/ChatType';

@Component({
    selector: 'app-chat-question',
    templateUrl: './chat-question.component.html',
    styleUrls: ['./chat-question.component.scss'],
})
export class ChatQuestionComponent implements OnInit,OnChanges {
    @Input() interaction: IChatRequest;
    @Input() interactionId: string;
    @Input() showContextLimitError: boolean;
    @Input() outOfContextIndex: number;
    @Input() activeChat:IChat;
    @Output() editQuestion = new EventEmitter<{
        editedText: string,
        chatId: string,
        interactionId: string,
        isEdit: boolean
    }>();
    chatSubscription: Subscription = new Subscription();
    @Input() questionImages:any ={};
    questionImagesURLS:any[]=[]

    showEditIcon: boolean = false;
    isEditMode: boolean = false;
    editedText: string = '';
    showEditTooltip: boolean = false;

    constructor(private chatservice: ChatServices, private sanitizer:DomSanitizer) { }

    ngOnInit(): void {
        this.interaction['requestText'] = this.interaction['requestText'].replace(/\$(?=\d)/g, '\\\\$');
      }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['questionImages']) {
            if(this.questionImages && Object.keys(this.questionImages)?.length > 0){
                this.questionImagesURLS = this.questionImagesArray
            }
        }
    }

    downloadImage(event: MouseEvent): void {
      event.stopPropagation();
    }

    get questionImagesArray() {
      return Object.keys(this.questionImages).map(key => {
          return {
              imageName: key,
              ...this.questionImages[key]
          };
      });
  }

  get isDeepResearchChat(): boolean {
    return this.activeChat?.chatType === ChatType.deepResearch ||
      this.chatservice.getChatType() === ChatType.deepResearch;
  }

  enableEditMode(): void {
    this.isEditMode = true;
    this.editedText = this.interaction.requestText;
  }

  cancelEdit(): void {
    this.isEditMode = false;
    this.editedText = '';
    this.showEditTooltip = false;
  }

  sendEditedQuestion(): void {
    if (this.editedText.trim()) {
      this.editQuestion.emit({
        editedText: this.editedText,
        chatId: this.activeChat.chatId,
        interactionId: this.interactionId,
        isEdit: true
      });
      this.isEditMode = false;
      this.editedText = '';
    }
  }

}
